import React from "react";
import { IconType } from "./type";

const IconTwitter = ({ width = 19, height = 15, fill = "white" }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.32 2.04999C20.5242 2.40886 19.6774 2.64165 18.81 2.73999C19.7234 2.19163 20.4086 1.33248 20.74 0.319987C19.8909 0.821012 18.9652 1.17912 18 1.37999C17.4001 0.739296 16.6212 0.294079 15.7648 0.102316C14.9083 -0.0894459 14.0139 -0.018867 13.1981 0.304862C12.3823 0.62859 11.6829 1.19047 11.191 1.91732C10.699 2.64417 10.4373 3.50231 10.44 4.37999C10.4403 4.71632 10.4772 5.05163 10.55 5.37999C8.80048 5.30037 7.08767 4.85107 5.52435 4.06165C3.96103 3.27223 2.58266 2.16061 1.48 0.799987C0.921551 1.76385 0.751334 2.90427 1.00399 3.9892C1.25664 5.07412 1.91318 6.02201 2.84 6.63999C2.13832 6.62342 1.45148 6.43454 0.84 6.08999V6.08999C0.842079 7.10086 1.19217 8.08019 1.8314 8.8633C2.47063 9.6464 3.36002 10.1855 4.35 10.39C3.97069 10.486 3.58126 10.5364 3.19 10.54C2.91479 10.5386 2.64029 10.5118 2.37 10.46C2.65567 11.321 3.20163 12.072 3.93248 12.6094C4.66332 13.1468 5.54299 13.444 6.45 13.46C4.90677 14.7087 2.98514 15.3963 1 15.41C0.65 15.41 0.3 15.41 0 15.36C1.99834 16.6569 4.32773 17.3512 6.71 17.36C8.35001 17.3707 9.97574 17.0549 11.4925 16.431C13.0092 15.8071 14.3866 14.8876 15.5444 13.726C16.7023 12.5645 17.6173 11.1842 18.2364 9.66542C18.8554 8.14669 19.166 6.51995 19.15 4.87999V4.30999C20.008 3.69545 20.7468 2.92959 21.33 2.04999H21.32Z"
        fill={fill}
      />
    </svg>
  );
};

export default IconTwitter;
